import type { BaseSlideProps, VideoContent } from './SlideLayout.types';

export function VideoSlide({ title, content, accentColor }: BaseSlideProps) {
  const { videoUrl, embedUrl, caption, poster } = content as VideoContent;

  return (
    <div
      className="slide-content animate-fade-in-up"
      style={{ '--color-accent': accentColor } as React.CSSProperties}
    >
      <h2 className="text-3xl font-serif font-bold mb-6 accent-text">
        {title}
      </h2>

      <div className="rounded-xl overflow-hidden bg-slate-900 aspect-video max-w-4xl mx-auto">
        {embedUrl ? (
          <iframe
            src={embedUrl}
            title={title}
            className="w-full h-full"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          />
        ) : videoUrl ? (
          <video
            src={videoUrl}
            poster={poster}
            controls
            className="w-full h-full"
            preload="metadata"
          >
            Your browser does not support the video tag.
          </video>
        ) : (
          <div className="w-full h-full flex items-center justify-center text-slate-500">
            <p>Configure <code>videoUrl</code> or <code>embedUrl</code> in slides config.</p>
          </div>
        )}
      </div>

      {caption && (
        <p className="mt-4 text-center text-slate-600 dark:text-slate-400 text-sm max-w-2xl mx-auto">
          {caption}
        </p>
      )}
    </div>
  );
}
